import { Spinner } from '@verisart/shared'
import { classNames } from '@verisart/shared/src/utils/classNames'
import { PropsWithChildren } from 'react'

type ButtonProps = {
  loading?: boolean
  fullWidth?: boolean
  borderless?: boolean
  testName?: string
  secondary?: boolean
  disabledColour?: boolean
  customClassName?: string
} & Pick<
  // Do NOT add `className`! // If you need extra native props exposed, add them here on a case by case basis.
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >,
  'onClick' | 'disabled' | 'type'
>

// Do not add className to this - follow the props pattern
const Button: React.FC<PropsWithChildren<ButtonProps>> = ({
  onClick,
  children,
  loading,
  fullWidth,
  disabled,
  testName,
  secondary,
  disabledColour,
  customClassName,
}) => {
  return (
    <button
      data-test={testName}
      disabled={disabled || loading}
      onClick={onClick}
      className={classNames(
        customClassName,
        'ver-rounded-default ver-h-11 ver-border-1 ver-py-4 ver-flex ver-items-center ver-justify-center',
        disabled
          ? disabledColour
            ? 'ver-text-disabled ver-border-disabled'
            : 'ver-opacity-50'
          : secondary
          ? 'ver-bg-transparent ver-text-secondary ver-border-secondary'
          : 'ver-bg-primary ver-text-surface',
        fullWidth
          ? 'ver-w-full ver-font-bold'
          : 'ver-px-24 ver-whitespace-nowrap'
      )}
    >
      {loading ? <Spinner /> : children}
    </button>
  )
}

export default Button
